import React, { useState, useEffect, forwardRef } from 'react';
import './tableEmployees.css'
import moment from 'moment-timezone';
import 'moment/locale/es-us';
import { Table, Button, Flex } from 'antd';

import {
    EyeOutlined,
    DeleteOutlined
} from '@ant-design/icons';

const TableEmployees = forwardRef((props, ref) => {
    const [dataSource, setDataSource] = useState([])
    const [columns, setColumns] = useState([])

    useEffect(() => {
        moment.locale('es-us');
    }, []);

    const catalogFilters = (items, labelKey) =>
        (items || []).map(item => ({ text: item[labelKey], value: item[labelKey] }));

    useEffect(() => {
        const { catalogs = {} } = props;
        const { organizationHqs = [], managementAreas = [], areas = [], jobCategories = [], jobTitles = [] } = catalogs;

        const cols = [
            {
                title: <div style={{ textAlign: "center" }}>Nombre Completo</div>,
                dataIndex: "empl_fullName",
                key: "empl_fullName",
                sorter: true,
                render: (text, row) => <span>{`${row.empl_first_name} ${row.empl_last_name}`}</span>,
            },
            {
                title: <div style={{ textAlign: "center" }}>Número de identificación</div>,
                dataIndex: "empl_dni",
                key: "empl_dni",
                sorter: true,
            },
            {
                title: <div style={{ textAlign: "center" }}>Email</div>,
                dataIndex: 'empl_email',
                key: 'empl_email',
            },
            {
                title: <div style={{ textAlign: "center" }}>Sede</div>,
                dataIndex: "empl_organization_hq_name",
                key: "empl_organization_hq_name",
                sorter: true,
                filters: catalogFilters(organizationHqs, 'ohq_location'),
            },
            {
                title: <div style={{ textAlign: "center" }}>Gerencia</div>,
                dataIndex: "empl_management_area_name",
                key: "empl_management_area_name",
                sorter: true,
                filters: catalogFilters(managementAreas, 'mna_management_area'),
            },
            {
                title: <div style={{ textAlign: "center" }}>Área</div>,
                dataIndex: "empl_area_name",
                key: "empl_area_name",
                sorter: true,
                filters: catalogFilters(areas, 'area_area'),
            },
            {
                title: <div style={{ textAlign: "center" }}>Categoría del cargo</div>,
                dataIndex: "empl_job_category_name",
                key: "empl_job_category_name",
                sorter: true,
                filters: catalogFilters(jobCategories, 'jct_category'),
            },
            {
                title: <div style={{ textAlign: "center" }}>Cargo</div>,
                dataIndex: "empl_job_title_name",
                key: "empl_job_title_name",
                sorter: true,
                filters: catalogFilters(jobTitles, 'jtt_title'),
            },
            {
                title: '',
                dataIndex: 'org_actions',
                key: 'org_actions',
                align: "center",
                fixed: "right",
                width: 96,
                render: (text, row) => (
                    <Flex gap="small" align="center" justify="center" style={{ flexWrap: 'nowrap' }}>
                        <Button onClick={() => setEmployeesValuesToSee(row)} style={{ backgroundColor: "#293790", color: "white" }} icon={<EyeOutlined style={{ fontSize: 16 }} />} size={"small"} title='Ver información del colaborador' />
                        <Button
                            onClick={() => deleteEmployee(row)}
                            danger
                            icon={<DeleteOutlined style={{ fontSize: 16 }} />}
                            size={"small"}
                            title='Eliminar colaborador'
                        />
                    </Flex>
                )
            }
        ];

        setColumns(cols);
        setDataSource(props.data);
    }, [props.data, props.catalogs]);

    const setEmployeesValuesToSee = (org) => {
        props.setEmployeesValuesToSee(org);
    }

    const deleteEmployee = (employee) => {
        if (props.deleteEmployee) {
            props.deleteEmployee(employee);
        }
    }

    return (
        <Table
            className="custom-green-table"
            size={"small"}
            dataSource={dataSource}
            columns={columns}
            rowKey="empl_id"
            onChange={props.onChange}
            pagination={{
                current: props.currentPage || 1,
                pageSize: props.pageSize || 20,
                total: props.total || 0,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                showTotal: (total) => `${total} colaboradores`,
                position: ['bottomRight'],
            }}
            scroll={{ x: 'max-content' }}
        />
    )
})

export default TableEmployees;